import { fetchTranslations, updateTranslations } from "./dbutils";

// ── UUID ─────────────────────────────────────────────────────────────────────
// crypto.randomUUID is only available in secure contexts (HTTPS/localhost).
// Fall back to a manual RFC4122 v4 generator when it isn't present.
export function uuid() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = [...bytes].map((b) => b.toString(16).padStart(2, "0"));
    return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`;
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// ── Clip lead time ──────────────────────────────────────────────────────────
// Number of seconds to start a clip *before* an event's timestamp when viewing
// event clips. Configurable in Settings.
export const CLIP_LEAD_TIME_KEY = "psts_clip_lead_time";
export const DEFAULT_CLIP_LEAD_TIME = 3;

export function getClipLeadTime() {
  const raw = parseFloat(localStorage.getItem(CLIP_LEAD_TIME_KEY));
  return Number.isFinite(raw) && raw >= 0 ? raw : DEFAULT_CLIP_LEAD_TIME;
}

export async function initPageTranslations(phrases, page) {
  const lang = localStorage.getItem("language") || "vie";
  var trs = await fetchTranslations(lang, page);
  if (!trs) {
    trs = { language: lang, page: page, phrases: {} };
  }
  var tr = {};
  for (var phrase of phrases) {
    if (trs.phrases[phrase] === undefined) {
      trs.phrases[phrase] = lang === "en" ? phrase : "";
    }
    tr[phrase] = trs.phrases[phrase] ? trs.phrases[phrase] : phrase;
  }
  await updateTranslations(trs);
  return tr;
}

export function getDefaultAvailableTimeslots() {
  const daylabels = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

  var a = [];
  for (var nd = 0; nd < daylabels.length; nd++) {
    const ad = { day: daylabels[nd], dayIndex: nd, slots: [0, 0, 0, 0] };
    a.push(ad);
  }
  return a;
}

export function availableSlots(avs, ndays, height, width) {
  const wdaylabels =
    ndays === 5
      ? ["MON", "TUE", "WED", "THU", "FRI"]
      : ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
  const slotlabels = ["", "", "", ""];
  const timeLabels = [
    "8.30am – 10.30am",
    "10.30am – 12.30pm",
    "12.30pm – 3.00pm",
    "3.00pm – 5.00pm",
  ];
  const labelclass = "text-center text-[8px] h-[" + height + "px]";
  const windowclass = "flex flex-col w-full h-[" + (height + 1) * 5 + "px]";
  return (
    <div className={windowclass}>
      <table className="min-w-full">
        <thead className="text-current">
          {wdaylabels.map((dl) => (
            <th
              key={dl}
              scope="col"
              // style={{
              //   // minHeight: height,
              //   height: height,
              //   // minWidth: width,
              //   width: width,
              // }}
              className={labelclass}
            >
              {dl}
            </th>
          ))}
        </thead>
        <tbody className="">
          {slotlabels.map((sl, i) => (
            <tr className="" style={{ height: height, width: width }}>
              {avs &&
                avs
                  .filter((obj) => wdaylabels.includes(obj.day))
                  .map((tsav, j) => (
                    <td className="text-center">
                      <div
                        style={{ height: height, width: width }}
                        className={
                          tsav.slots[i] === 1 ? "bg-success" : "bg-error"
                        }
                      >
                        {width <= 20 ? (
                          <></>
                        ) : (
                          <p className="text-[8px] text-center text-white p-1">
                            {timeLabels[i]}
                          </p>
                        )}
                      </div>
                    </td>
                  ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function guideTextColour(guide) {
    if (!guide || !guide.scheduleColour) return "";
    if (
      pickTextColorBasedOnBgColorAdvanced(
        guide.scheduleColour,
        "#FFFFFF",
        "#000000"
      ) === "#FFFFFF"
    ) {
      return "text-center text-white";
    }
    return "text-center text-black";
  }
  
  export function pickTextColorBasedOnBgColorAdvanced(
    bgColor,
    lightColor,
    darkColor
  ) {
    var color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
    var r = parseInt(color.substring(0, 2), 16); // hexToR
    var g = parseInt(color.substring(2, 4), 16); // hexToG
    var b = parseInt(color.substring(4, 6), 16); // hexToB
    var uicolors = [r / 255, g / 255, b / 255];
    var c = uicolors.map((col) => {
      if (col <= 0.03928) {
        return col / 12.92;
      }
      return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    return L > 0.179 ? darkColor : lightColor;
  }
  
  export function getAge(dob) {
    var today = new Date();
    var birthDate = new Date(dob * 1000);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  
  export function interpolate(a, b, frac) {
  // points A and B, frac between 0 and 1
  var nx = a.x + (b.x - a.x) * frac;
  var ny = a.y + (b.y - a.y) * frac;
  return { x: nx, y: ny };
}

export function drawArrowHead(ctx, bs, be, ahl, ahar, col, scolor) {
    ctx.lineWidth = 1.0;
    ctx.strokeStyle = scolor;
    ctx.fillStyle = col;

    var arrowOrigin = {};
    var arrowTip = {};
    var arrowHeadBase = {};
    var arrowHeadWing1 = {};
    var arrowHeadWing2 = {};
    var arrowHeadBase2 = {};
    var arrowHeadWing21 = {};
    var arrowHeadWing22 = {};
    var deltaX = 0.0;
    var deltaY = 0.0;

    var deltaXBase = 0.0;
    var deltaYBase = 0.0;

    var headToShaftRatio = 0.0;
    var deltaXWing = 0.0;
    var deltaYWing = 0.0;

    var mArrowLength;

    // The arrow origin will be at the center of the view
    arrowOrigin.x = bs.x;
    arrowOrigin.y = bs.y;

    // Create the path that will contain the arrow drawing instructions
    // and begin drawing.
    ctx.beginPath();
    //	CGPathMoveToPoint(arrowPath, NULL, arrowOrigin.x, arrowOrigin.y);

    // Calculate the arrow tip location from the polar coordinates
    deltaX = be.x - bs.x;
    deltaY = be.y - bs.y;
    arrowTip.x = be.x;
    arrowTip.y = be.y;

    mArrowLength = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    //	mArrowAngle = deltaY === 0 ? 0 : atan(-deltaX / deltaY);
    //	mArrowAngle = (mArrowAngle * 180) / PI;

    var mArrowHeadLength = ahl;
    var mArrowHeadAspectRatio = ahar;

    // Define the arrow shaft
    //	CGPathAddLineToPoint(arrowPath, NULL, arrowTip.x, arrowTip.y);

    headToShaftRatio = mArrowHeadLength / mArrowLength;
    deltaXBase = headToShaftRatio * deltaX;
    deltaYBase = headToShaftRatio * deltaY;
    // Calculate the location of the base of the arrow head
    arrowHeadBase.x = arrowTip.x - deltaXBase;
    arrowHeadBase.y = arrowTip.y - deltaYBase;

    arrowHeadBase2.x = arrowTip.x - deltaXBase / 2;
    arrowHeadBase2.y = arrowTip.y - deltaYBase / 2;

    // Calculate the wing tips of the arrow head
    deltaXWing = mArrowHeadAspectRatio * deltaXBase;
    deltaYWing = mArrowHeadAspectRatio * deltaYBase;
    arrowHeadWing1.x = arrowHeadBase.x - deltaYWing;
    arrowHeadWing1.y = arrowHeadBase.y + deltaXWing;
    arrowHeadWing2.x = arrowHeadBase.x + deltaYWing;
    arrowHeadWing2.y = arrowHeadBase.y - deltaXWing;

    arrowHeadWing21.x = arrowHeadBase2.x - deltaYWing / 2;
    arrowHeadWing21.y = arrowHeadBase2.y + deltaXWing / 2;
    arrowHeadWing22.x = arrowHeadBase2.x + deltaYWing / 2;
    arrowHeadWing22.y = arrowHeadBase2.y - deltaXWing / 2;

    // Define the arrow head wings
    ctx.moveTo(arrowTip.x, arrowTip.y);
    ctx.lineTo(arrowHeadWing1.x, arrowHeadWing1.y);
    ctx.lineTo(arrowHeadWing2.x, arrowHeadWing2.y);
    ctx.lineTo(arrowTip.x, arrowTip.y);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
  }

  export function stringToPoint(ballPos) {
  var pos = ballPos ? ballPos.split(",") : [0, 0];
  var x = pos[0];
  var y = pos[1];
  return { x: x, y: y };
}

export function playerInitialAndName(ev) {
  if (ev.player.firstName === undefined) {
    return "";
  }
  const initial =
    ev.player.firstName.length === 0
      ? ""
      : ev.player.firstName.substring(0, 1) + ".";
  const playerLastName =
    ev.player.lastName !== null ? ev.player.lastName.toUpperCase() : "";
  return initial + " " + playerLastName;
}

export function realGameScores(e) {
  const gs = ["00", "15", "30", "40", "A"];
  const p1s =
    e.scores.player1GameScore < 4
      ? gs[e.scores.player1GameScore]
      : e.scores.player1GameScore <= e.scores.player2GameScore
      ? "40"
      : "A";
  const p2s =
    e.scores.player2GameScore < 4
      ? gs[e.scores.player2GameScore]
      : e.scores.player2GameScore <= e.scores.player1GameScore
      ? "40"
      : "A";
  return p1s + "-" + p2s;
}

